// extracted by mini-css-extract-plugin
module.exports = {"tooltip-rateList-category":"rateCategorySeat_tooltip-rateList-category__2-EVj"};